<div class="graphic-body__content">
  <h2>Not found</h2>
</div>
